<template>
  <b-container>
    <b-form @submit="onSubmit" @reset="onReset">
      <div class="form-row">
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp1"
            label-cols="2"
            label="Scheme"
            label-size="sm"
            label-for="ipLoanType"
          >
            <b-select
              id="ipLoanType"
              class="form-control"
              value-field="LoanType"
              size="sm"
              text-field="SchemeName"
              :options="schemes"
              v-model="form.LoanType"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp2"
            label-cols="3"
            label="District"
            label-size="sm"
            label-for="ipDistrict"
          >
            <b-select
              id="ipDistrict"
              :options="districts"
              value-field="DistID"
              text-field="DistName"
              size="sm"
              :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
              v-model="form.DistrictID"
              class="form-control"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp3"
            label-cols="2"
            label="Bank"
            label-size="sm"
            label-for="ipAPSts"
          >
            <b-select
              id="ipAPSts"
              class="form-control"
              :options="banks"
              value-field="BankID"
              text-field="BankName"
              required
              size="sm"
              v-model="form.BankID"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp4"
            label-cols="4"
            label="Application No"
            label-size="sm"
            label-for="ipAppNum"
          >
            <b-form-input
              type="text"
              size="sm"
              id="ipAppNum"
              v-model="form.LoanApplicationNo"
            />
          </b-form-group>
        </b-col>
      </div>
      <b-row>
        <b-col class="mt-2" md="2">
          <b-form-group
            id="grp14"
            label-cols="3"
            label="LOI No"
            label-size="sm"
            label-for="ipLoiNum"
          >
            <b-form-input
              type="text"
              size="sm"
              id="ipLoiNum"
              v-model="form.LOINumber"
            />
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="3">
          <b-form-group
            id="grp13"
            label-cols="4"
            label="Claim Date"
            label-size="sm"
            label-for="ipAPDt"
          >
            <date-picker
              v-model="UpdateDate"
              format="DD-MM-YYYY"
              id="ipAPDt"
              lang="en"
              range
              size="small"
              style="width: 220px"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="3">
          <b-form-group
            id="grp2"
            label-cols="3"
            label="Claim Status"
            label-size="sm"
            label-for="ipDistrict2"
          >
            <b-select
              id="ipDistrict2"
              :options="approvalStatus"
              value-field="Id"
              text-field="ApplicationStatus"
              size="sm"
              v-model="form.ClaimStatus"
              class="form-control"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="2">
          <b-form-group
            id="grp2"
            label-cols="3"
            label="Owner"
            label-size="sm"
            label-for="ipowner"
          >
            <b-select
              id="ipowner"
              :options="statusOwner"
              size="sm"
              v-model="form.StatusOwner"
              class="form-control"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-0">
          <b-button type="submit" size="sm" variant="primary" class="my-2"
            >Search</b-button
          >
          <b-button type="reset" size="sm" variant="secondary" class="my-2"
            >Reset</b-button
          >
        </b-col>
      </b-row>
      <b-row v-if="isLoadingM">
        <b-col>
          <Spinner size="32" message="Loading..." v-if="isLoadingM"></Spinner>
          <b-alert
            :show="showDismissibleAlertM"
            dismissible
            @dismissed="showDismissibleAlertM = false"
            :variant="variantM"
            >{{ alertTextM }}</b-alert
          >
        </b-col>
      </b-row>
    </b-form>
    <hr />
    <!-- <b-form @submit="onSubmit" @reset="onReset">
            <div class="form-row" >
                <div class="form-group col-md-5">
                    <label size="sm" label-cols="4" for="ipLoanType">Claim Paid Status</label>
                    <b-select id="ipLoanType" class="form-control" value-field="Id" size="sm"
                        text-field="ApplicationStatus" :options="paymentStatus" v-model="form.ClaimPaidStatus">
                    </b-select>
                </div>
                <div class="form-group col-md-4">
                    <label for="ipDistrict">District</label>
                    <b-select id="ipDistrict"
                        :options="districts"
                        value-field="DistID"
                        text-field="DistName"
                        required
                        size="sm"
                        v-model="form.DistrictID"
                        class="form-control">
                    </b-select>
                </div>
                <div class="form-group col-md-3">
                    <label for="ipAPSts">Status</label>
                    <b-select id="ipAPSts" class="form-control" :options="approvalStatus"
                        value-field="Id"
                        text-field="ApplicationStatus"
                        required
                        size="sm"
                        v-model="form.ClaimStatus">
                    </b-select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="inputCity">Application No</label>
                    <input type="text" class="form-control" id="inputCity" v-model="form.ApplicationNo">
                </div>
                <div class="form-group col-md-4">
                    <label for="ipMobile">Mobile No</label>
                    <input type="text" class="form-control" id="ipMobile" v-model="form.MobileNo">
                </div>
                <div class="form-group col-md-2" style="valign:bottom">
                    <b-button type="submit" size="sm" variant="primary" style="margin-top:35px">Search</b-button>
                </div>


            </div>


    </b-form>-->

    <b-row>
      <b-col></b-col>
      <b-col md="4"></b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col md="4">
        <b-input-group>
          <b-form-input
            v-model="filter"
            placeholder="Type to Search"
            size="sm"
          />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''" size="sm"
              >Clear</b-btn
            >
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col></b-col>
      <b-col md="4">
        <b-form-group
          horizontal
          label="Sort"
          class="mb-0"
          label-size="sm"
          label-cols="1"
        >
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-input-group-append>
              <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-button
          variant="outline-success"
          size="sm"
          @click="downloadExcel"
          style="float: left; font-size: 1em; font-color: green"
          v-if="showxls"
        >
          <i class="fa fa-file-excel"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-container style="overflow-x: auto">
          <b-table
            show-empty
            selectable
            responsive="true"
            select-mode="single"
            head-variant="dark"
            empty-text="No Claim available for the query."
            stacked="md"
            bordered
            striped
            :items="claims"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            @row-selected="onRowSelected"
            style="font-size: 12px; width: 100%; margin-left: 0"
          >
            <!-- <template v-slot:cell(selected)="{ rowSelected }"> -->

            <template v-slot:cell(action)="row">
              <b-button
                size="sm"
                @click.stop="viewDisbursal(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="success"
                v-b-tooltip.hover
                title="View Details"
                >View</b-button
              >
            </template>
          </b-table>
        </b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
          size="sm"
        />
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group
          horizontal
          label="Per page"
          class="mb-0"
          label-size="sm"
          :label-cols="6"
        >
          <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
        </b-form-group>
      </b-col>
    </b-row>
    <div>
      <b-modal
        id="modalClaim"
        size="xl"
        title="Claim Details"
        scrollable
        hide-footer
      >
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Claim Details">
              <b-container>
                <!-- <b-row class="mb-2">
                  <b-col md="4">
                    <b style="font-size: 0.875rem">Full Name:</b>
                    {{ selectedApplication.FullName }}
                  </b-col>
                  <b-col style="font-size: 0.875rem" md="3">
                    <b>Adhar No:</b>
                    {{ selectedApplication.AdharNo }}
                  </b-col>
                </b-row> -->
                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="8">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              Applicant Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Full Name:</b
                                    >
                                    {{ selectedApplication.FullName }}
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem">Adhar No:</b>
                                    {{ selectedApplication.AdharNo }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>

                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="12">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              Loan Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Loan Bank:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.LoanBank
                                    }}</span>
                                  </td>
                                  <td colspan="3">
                                    <b style="font-size: 0.875rem"
                                      >Loan Bank Branch:</b
                                    >
                                    {{ selectedApplication.LoanBranch }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Sanction Amount(Rs):</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.SanctionAmount
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Disbursed Amount(Rs):</b
                                    >
                                    {{ selectedApplication.DisbursedAmount }}
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem">ROI(%):</b>
                                    {{ selectedApplication.ROI }}
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Tenure(Months):</b
                                    >
                                    {{ selectedApplication.LoanTenure }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>

                <!-- <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Loan Bank:</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.LoanBank
                    }}</span>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Loan Bank Branch:</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.LoanBranch
                    }}</span>
                  </b-col>
                </b-row>
                <b-row class="my-3" style="background-color: orange">
                  <b-col style="font-size: 0.875rem" md="2">
                    <b>Sanction Amount(Rs)</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.SanctionAmount
                  }}</b-col>
                  <b-col style="font-size: 0.875rem" md="2">
                    <b>Disbursed Amount(Rs)</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.DisbursedAmount
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>ROI</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.ROI
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>LoanTenure</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.LoanTenure
                  }}</b-col>
                </b-row> -->
                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="12">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              Bank Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem">Bank:</b>
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.BankName
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Loan Bank Branch:</b
                                    >
                                    {{ selectedApplication.BranchName }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Account No:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.BankAccountNo
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Total EMI Paid:</b
                                    >
                                    {{ selectedApplication.TotalEMIPaid }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>
                <!-- <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Applicant Bank:</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.BankName
                    }}</span>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Applicant Branch:</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.BranchName
                    }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Applicant Account No :</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.BankAccountNo
                    }}</span>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Total EMI Paid :</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.TotalEMIPaid
                    }}</span>
                  </b-col>
                </b-row> -->
                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="12">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              EMI Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Paid Date:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.EMIPaidDate
                                        | formatDate
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Paid Amount:</b
                                    >
                                    {{ selectedApplication.EMIPaidAmt }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Principal Amt:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.PrincipalAmt
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Interest Amt:</b
                                    >
                                    {{ selectedApplication.InterestAmt }}
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Penalty/Other Amt:</b
                                    >
                                    {{ selectedApplication.PenaltyCharges }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >EMI Paid Proof:</b
                                    >
                                    <a
                                      target="_blank"
                                      :href="
                                        getImgUrl(
                                          selectedApplication.UploadEMIPaidProof
                                        )
                                      "
                                      >View</a
                                    >
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Business Photo:</b
                                    >
                                    <span
                                      v-if="
                                        selectedApplication.UploadBusinessPhoto ==
                                          '' ||
                                        !selectedApplication.UploadBusinessPhoto
                                      "
                                      >Not Uploaded</span
                                    >
                                    <a
                                      v-else
                                      target="_blank"
                                      :href="
                                        getImgUrl(
                                          selectedApplication.UploadBusinessPhoto
                                        )
                                      "
                                      >View</a
                                    >
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>
                <!-- <b-row class="mb-2 mt-4" style="background-color: yellow">
                  <b-col style="font-size: 0.875rem" md="2">
                    <b>EMI Paid Date</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem" md="2">{{
                    selectedApplication.EMIPaidDate | formatDate
                  }}</b-col>
                  <b-col style="font-size: 0.875rem" md="2">
                    <b>EMI Paid Amt</b>
                  </b-col>
                  <b-col md="2" style="font-size: 0.875rem">{{
                    selectedApplication.EMIPaidAmt
                  }}</b-col>
                </b-row> -->
                <!-- <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Principal Amt</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.PrincipalAmt
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Interest Amt</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.InterestAmt
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Penalty Charges</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.PenaltyCharges
                  }}</b-col>
                </b-row> -->
                <!-- <b-row class="mb-2"> -->
                <!-- <b-col style="font-size:0.875rem"><b>UploadBankStmt</b></b-col><b-col style="font-size:0.875rem">{{selectedApplication.UploadBankStmt}}</b-col> -->
                <!-- <b-col style="font-size: 0.875rem">
                    <b>EMI Paid Proof</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <a
                      target="_blank"
                      :href="getImgUrl(selectedApplication.UploadEMIPaidProof)"
                      >View</a
                    >
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Business Photo</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <span
                      v-if="
                        selectedApplication.UploadBusinessPhoto == '' ||
                        !selectedApplication.UploadBusinessPhoto
                      "
                      >Not Uploaded</span
                    >
                    <a
                      v-else
                      target="_blank"
                      :href="getImgUrl(selectedApplication.UploadBusinessPhoto)"
                      >View</a
                    >
                  </b-col> -->
                <!-- </b-row> -->
                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="12">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              Claim Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Approval Status:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.ClaimStatus
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Payment Status:</b
                                    >
                                    {{ selectedApplication.ClaimPaymentStatus }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Claim Amount:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.InterestAmt
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Paid Amount:</b
                                    >
                                    {{ selectedApplication.TotalPaidClaim }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>
                <!-- <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Claim Status</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.ClaimStatus
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Claim Payment Status</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.ClaimPaymentStatus
                  }}</b-col>
                </b-row> -->
                <!-- <b-row class="mb-2"> -->
                <!-- <b-col style="font-size: 0.875rem">
                    <b>Total Claim Amount</b>
                  </b-col> -->
                <!-- <b-col style="font-size:0.875rem">{{selectedApplication.TotalClaimAmount}}</b-col> -->
                <!-- <b-col style="font-size: 0.875rem">{{
                    selectedApplication.InterestAmt
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Total Paid Claim</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.TotalPaidClaim
                  }}</b-col>
                </b-row> -->
                <hr />
                <div class="reg-form-box">
                  <Spinner
                    size="32"
                    message="Loading..."
                    v-if="isLoading"
                  ></Spinner>
                  <b-alert
                    :show="showDismissibleAlert"
                    dismissible
                    @dismissed="showDismissibleAlert = false"
                    :variant="variant"
                    >{{ alertText }}</b-alert
                  >
                  <b-form @submit="onSubmitApprove" v-if="showApproval">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <b-form-group
                          id="igAprvAmt"
                          label-cols-sm="4"
                          label-cols-lg="3"
                          label="Approved Amount"
                          label-for="ipAprvAmt"
                          label-size="sm"
                        >
                          <b-form-input
                            type="text"
                            size="sm"
                            id="ipAprvAmt"
                            v-model="formclm.ApprovedAmount"
                            @input="calculateReject"
                          />
                        </b-form-group>
                      </div>
                      <div class="form-group col-md-6">
                        <b-form-group
                          id="igRejectAmt"
                          label-cols-sm="4"
                          label-cols-lg="3"
                          label="Rejected Amount"
                          label-for="ipRejectAmt"
                          label-size="sm"
                        >
                          <b-form-input
                            type="text"
                            size="sm"
                            id="ipRejectAmt"
                            disabled
                            v-model="formclm.RejectedAmount"
                            @input="calculateApprove"
                          />
                        </b-form-group>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <b-form-group
                          id="fieldset-horizontal"
                          label-cols-sm="4"
                          label-cols-lg="3"
                          label="Approve Claim"
                          label-for="ipAprv"
                          label-size="sm"
                        >
                          <b-select
                            id="ipAprv"
                            :options="ApprovalStatus"
                            value-field="StatusID"
                            text-field="Status"
                            required
                            size="sm"
                            @change.native="checkReject"
                            v-model="formclm.ClaimStatusID"
                            class="form-control"
                          ></b-select>
                        </b-form-group>
                      </div>

                      <div class="form-group col-md-6">
                        <b-form-group
                          id="fieldset-horizontal2"
                          label-cols-sm="4"
                          label-cols-lg="3"
                          label="Reject Reason"
                          label-for="ipReason"
                          label-size="sm"
                        >
                          <b-select
                            id="ipReason"
                            :options="RejectReasons"
                            value-field="RejectedID"
                            text-field="RejectedTypeName"
                            required
                            size="sm"
                            :disabled="!isReject"
                            v-model="formclm.RejectReason"
                            class="form-control"
                          ></b-select>
                        </b-form-group>
                      </div>
                      <div class="form-group col-md-4"></div>
                    </div>
                    <div class="form-row">
                      <div
                        class="form-group col-md-12"
                        style="text-align: left"
                      >
                        <b-form-group
                          id="fieldset-horizontal"
                          label-cols-sm="4"
                          label-cols-md="1"
                          label="Remarks"
                          label-for="ipRemarks"
                          label-size="sm"
                        >
                          <b-form-textarea
                            id="ipRemarks"
                            v-model="formclm.Remarks"
                            required
                            size="sm"
                            rows="2,"
                            max-rows="4"
                            placeholder="Remarks"
                          ></b-form-textarea>
                        </b-form-group>
                      </div>
                    </div>
                    <b-col style="text-align: center">
                      <b-button type="submit" variant="primary"
                        >Submit</b-button
                      >
                    </b-col>
                  </b-form>
                </div>
                <b-row>
                  <b-col cols="10" offset="1">
                    <h5 class="reg-form-title text-primary">
                      Approval History
                    </h5>
                    <b-table
                      show-empty
                      selectable
                      select-mode="multi"
                      head-variant="dark"
                      empty-text="No Applications available."
                      stacked="md"
                      bordered
                      striped
                      :items="approvalRemarks"
                      :fields="approvalFields"
                      variant="dark"
                      style="font-size: 12px"
                    ></b-table>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="LOI">
              <l-o-i-details
                :UserID="this.selectedApplication.UserID"
                :ApplicationID="this.selectedApplication.LoanApplicationID"
                :Loantype="this.selectedApplication.LoanType"
              ></l-o-i-details>
            </b-tab>
            <b-tab title="Sanction Letter">
              <sanction-details
                :UserID="this.selectedApplication.UserID"
              ></sanction-details>
            </b-tab>
            <b-tab title="Disbursals">
              <disbursal-details
                :UserID="this.selectedApplication.UserID" :LoanType="this.form.LoanType"
              ></disbursal-details>
            </b-tab>
            <b-tabs v-model="activeTab" card>

</b-tabs>

            <b-tab title="Edit Docs">
              <document-upload
                :UserID="this.selectedApplication.UserID"
                :Stage="stage"
                :Id="this.selectedApplication.ClaimEMIID"
              ></document-upload>
            </b-tab>
            <b-tab title="Profile">
              <profile-approval
                :UserID="this.selectedApplication.UserID"
                :ApplicationStatus="1"
              ></profile-approval>
            </b-tab>
            <b-tab title="Claim History">
              <claim-list-admin
                :ClaimUserID="this.selectedApplication.UserID"
              ></claim-list-admin>
            </b-tab>


  <b-tab title="EMI Schedule">
    <e-m-i-schedule
      :ApplicationID="this.selectedApplication.LoanApplicationID"
    ></e-m-i-schedule>
  </b-tab>
          </b-tabs>
        </b-card>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import { detectTenant, filterByCaste } from "@/tenantConfig";
import * as _ from "lodash";
import axios from "axios";
import Formatter from "@/Formatter";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import DisbursalDetails from "./ClaimComponents/DisbursalDetails";
import EMISchedule from "./ClaimComponents/EMISchedule";
import LOIDetails from "./ClaimComponents/LOIDetails";
import SanctionDetails from "./ClaimComponents/SanctionDetails";
import ProfileApproval from "@/components/Admin/ViewPersonalDetailsProfile";
import GroupProfileApproval from "@/components/Admin/ViewGroupDetailsProfile";
import XLSX from "xlsx";
import DocumentUpload from "@/components/ClaimApproval/DocumentUpload";
import ClaimListAdmin from "@/components/ClaimUpload/ClaimListAdmin"

export default {
  components: {
    Spinner,
    DatePicker,
    SanctionDetails,
    DisbursalDetails,
    EMISchedule,
    LOIDetails,
    DocumentUpload,
    ProfileApproval,
    ClaimListAdmin
  },
  data() {
    return {
      show: false,
      showsts: false,
      showxls: false,
      showApproval: false,
      statusOwner: [
        "All",
        "Accounts",
        "Auditor",
        "DGM",
        "GM",
        "MD",
        "ToBePaid",
        "Paid",
        "Applicant",
        "Rejected",
      ],
      isReject: false,
      modalInfo: "",
      UpdateDate: [null, null],
      districts: [],
      schemes: [],
      approvalStatus: [],
      paymentStatus: [],
      claims: [],
      bscReport: "",
      bscReportPath: "",
      banks: [],
      fields: [
        { key: "FullName", label: "Full Name", sortable: true },
        { key: "SanctionAmount", label: "Sanction Amount", sortable: true },
        { key: "DisbursedAmount", label: "Disbursed Amount", sortable: true },
        { key: "TotalEMIPaid", label: "Total EMI Paid", sortable: true },
        { key: "ROI", label: "ROI%", sortable: true },
        { key: "LoanTenure", label: "Tenure (months)", sortable: true },
        {
          key: "EMIPaidDate",
          label: "EMI Paid Date",
          sortable: true,
          formatter: "convertDateFormat",
        },
        { key: "EMIPaidAmt", label: "EMI Paid Amt", sortable: true },
        { key: "PrincipalAmt", label: "Principal Amt", sortable: true },
        { key: "InterestAmt", label: "Interest Amt", sortable: true },
        { key: "PenaltyCharges", label: "Penalty Charges", sortable: true },
        { key: "ClaimStatus", label: "Claim Status", sortable: true },
        {
          key: "ClaimPaymentStatus",
          label: "Payment Status",
          sortable: true,
        },
        {
          key: "TotalClaimAmount",
          label: "Total Claim Amount",
          sortable: true,
        },
        {
          key: "ApprovedAmount",
          label: "Approved Amount",
          sortable: true,
        },
        { key: "TotalPaidClaim", label: "Total Paid Claim", sortable: true },

        { key: "action", label: "View" },
      ],
      selected: [],
      form: {
        DistrictID: "00000000-0000-0000-0000-000000000000",
        BankID: "00000000-0000-0000-0000-000000000000",
        ClaimStatus: 0,
        ClaimPaidStatus: 0,
        LoanApplicationNo: null,
        LOINumber: null,
        UserLoginID: null,
        RecoStatus: 0,
        ClaimStartDate: null,
        ClaimEndDate: null,
        LoanType: 1,
        StatusOwner: "All",
      },
      formclm: {
        ClaimStatusID: 1,
        RejectReason: 0,
        Remarks: "",
        UserID: "",
        ClaimID: "",
        ApprovedAmount: 0,
        RejectedAmount: 0,
      },
      RoleID: 0,
      ApprovalStatusAll: [],
      ApprovalStatus: [
        { StatusID: 1, Status: "Pending" },
        { StatusID: 2, Status: "Verified" },
        { StatusID: 6, Status: "Rejected" },
      ],
      approvalRemarks: [],
      approvalFields: [
        "ClaimStatus",
        "RejectionReason",
        "ApprovedAmount",
        "RejectedAmount",
        { key: "RejectRemarks", label: "Remarks" },
        { key: "LogDate", formatter: "convertDateFormat" },
        "ApproverName",
      ],
      RejectReasons: [],

      selectedApplication: {
        UserID: "00000000-0000-0000-0000-000000000000",
      },
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      pageOptions: [50,60,70,80,90,100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      showDismissibleAlertM: false,
      variantM: "success",
      alertTextM: "",
      isLoadingM: false,
      LoanDetails: {
        BankName: "--",
        BranchName: "--",
        ApprovedAmount: 0,
        DisbursementAmount: 0,
        ROI: 0,
        Tenure: 0,
      },
      stage: 4,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    userDistrict() {
      return this.$store.getters.getUserDistrict;
    },
  },
  filters: {
    formatDate(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
  },
  methods: {
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    getImgUrl(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          this.selectedApplication.UserID +
          "/" +
          pic
        );
      }
    },
    Add() {
      this.$router.push("/claimupload");
    },
    async viewDisbursal(item, index, target) {
      this.selectedApplication = item;
      this.formclm.ClaimID = item.ClaimEMIID;
      this.formclm.ApprovedAmount = item.ApprovedAmount;
      this.formclm.RejectedAmount = item.InterestAmt - item.ApprovedAmount;
      this.formclm.RejectReason = 0;
      this.formclm.Remarks = "";
      this.formclm.ClaimStatusID = item.ClaimStatusID;
      this.$root.$emit("bv::show::modal", "modalClaim");

      this.ApprovalStatus = _.filter(this.ApprovalStatusAll, {
        ClaimStatus: item.ClaimStatusID,
      });
      console.log(JSON.stringify(item));
      if (this.ApprovalStatus.length > 0) {
        this.showApproval = true;
      } else {
        this.showApproval = false;
      }
      //(JSON.stringify(item));
      try {
        let promiseA = apis.ReadClaimApprovalRemarks(item.ClaimEMIID);

        var response = await promiseA;

        if (response.status == 200) {
          this.approvalRemarks = response.body;
        }
      } catch (err) {
        this.$dialog.alert("Error while Reading Approval Remarks");
      }
    },
    calculateReject(evt) {
      if (evt != "") {
        this.formclm.RejectedAmount = (
          this.selectedApplication.InterestAmt - parseFloat(evt)
        ).toFixed(2);
      }
    },
    calculateApprove(evt) {},
    onRowSelected(items) {
      this.selected = items;
    },
    checkReject(evt) {
      let id = parseInt(evt.target.value);
      let appStatus = _.filter(this.ApprovalStatus, { StatusID: id });
      if (appStatus) {
        if (appStatus.length > 0) {
          this.isReject = appStatus[0].ISReject;
          if (!this.isReject) {
            this.form.RejectReason = 0;
          }
        }
      }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    deleteDocument(item, index, button) {
      //console.log(item);
      this.selecteObj.Document = item.Document;
      this.selecteObj.Path = item.Path;

      let info = "You want to delete record for:" + "\n" + item.Document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getApprovalStatus() {
      let promise = apis.getClaimStatusMstr();
      promise
        .then((response) => {
          if (response.status == 200) {
            this.approvalStatus = response.body;
            this.approvalStatus.unshift({
              Id: 0,
              ApplicationStatus: "All",
            });
            //this.form.ClaimStatus = 0;
          } else {
            this.alertTextM =
              "Unable to Load Approval Status List, " + response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
          this.isLoadingM = false;
        })
        .catch((err) => {
          this.alertTextM =
            "Unable to Load Approval Status List, " + err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },

    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then((response) => {
          if (response.status == 200) {
            this.districts = response.body;
            this.districts.unshift({
              DistID: "00000000-0000-0000-0000-000000000000",
              DistName: "All",
            });

            if (this.userDistrict != "00000000-0000-0000-0000-000000000000") {
              this.form.DistrictID = this.userDistrict;
            }
            this.isLoadingM = false;
            //this.$router.push("/");
          } else {
            this.alertTextM = response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
        })
        .catch((err) => {
          this.alertTextM = err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },
    ReadBanks() {
      let promise = apis.ReadBankMaster();

      promise
        .then((response) => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.banks = response.body;
            this.banks.unshift({
              BankID: "00000000-0000-0000-0000-000000000000",
              BankName: "All",
            });
            this.isLoadingM = false;
          } else {
            this.alertTextM = response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
        })
        .catch((err) => {
          this.alertTextM = err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },
    getSchemes() {
      let promise = apis.getSchemes();

      promise
        .then((response) => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.schemes = response.body;
            this.form.LoanType = this.$store.getters.getLoanType;
          } else {
            this.alertTextM = "Unable to Load Scheme List, " + response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
          this.isLoadingM = false;
        })
        .catch((err) => {
          this.alertTextM = "Unable to Load Scheme List, " + err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },
    getPaymentStatus() {
      let promise = apis.getPaymentStatusMstr();
      promise
        .then((response) => {
          if (response.status == 200) {
            this.paymentStatus = response.body;
            this.paymentStatus.unshift({ Id: 0, ApplicationStatus: "All" });
            this.form.ClaimPaidStatus = 0;
          } else {
            this.alertTextM =
              "Unable to Load Approval Status List, " + response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
          this.isLoadingM = false;
        })
        .catch((err) => {
          this.alertTextM =
            "Unable to Load Approval Status List, " + err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },

    onSubmitApprove(evt) {
      evt.preventDefault();
      let promise = apis.UpdateClaimStatus(this.formclm);

      promise
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            this.alertText = response.body;
            this.variant = "success";
            this.showDismissibleAlert = true;
            this.isLoading = false;
            this.getDisbursals();
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.getDisbursals();
    },

    getDisbursals() {
      this.isLoadingM = true;
      this.showDismissibleAlert = false;
      if (this.UpdateDate != null) {
        this.form.ClaimStartDate = Formatter.convertDateFormatYMD(
          this.UpdateDate[0]
        );
        this.form.ClaimEndDate = Formatter.convertDateFormatYMD(
          this.UpdateDate[1]
        );
      } else {
        this.form.ClaimStartDate = null;
        this.form.ClaimEndDate = null;
      }

      if (this.form.ClaimStatus == 4 || this.form.StatusOwner == "ToBePaid") {
        this.claims = [];
        this.showxls = true;
      } else {
        this.showxls = false;
      }

      //let promise = apis.readAllClaims(this.form);
      let promise = apis.ReadClaimEMIForApproval(this.form);

      promise
        .then((response) => {
          //console.log(response);
          if (response.status == 200) {
            this.claims = filterByCaste(response.body, detectTenant());
            this.totalRows = this.claims.length;
          } else {
            this.alertTextM = response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
          this.isLoadingM = false;
        })
        .catch((err) => {
          this.alertTextM = err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },
    onReset(evt) {
      evt.preventDefault();
      this.form = {
        DistrictID: "",
        ApplicationStatusID: 0,
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: "",
      };
    },
    async downloadExcel() {
      // var columns = [
      //   "Claim ID",
      //   "LOI No",
      //   "Applicant Name",
      //   "Aadhar ID",
      //   "Bank Name",
      //   "Branch Name",
      //   "Account No",
      //   "Amount"
      // ];

      // var columns = [
      //   "SR. NO.",
      //   "SENDER NAME",
      //   "DEBIT ACCOUNT NO.",
      //   "BENEFICIARY NAME",
      //   "AADHAR ID",
      //   "BENEFICIARY A/C NO.",
      //   "BENEFICIARY IFSC CODE",
      //   "BENEFICIARY BANK NAME",
      //   "BENEFICIARY  BRANCH NAME",
      //   "AMOUNT",
      //   "REMARKS",
      // ];

      var columns = [
        "Sr. No.",
        "Debit Account",
        "Payment Date",
        "Beneficiary Name",
        "LOI Number",
        "Beneficiary Aadhaar Number",
        "Amount",
        "Taluka",
        "District",
        "Mobile No.",
        "Email",
        "Zip",
        "Corporations Remarks",
        "Destination Bank IIN",
        "Payment Product Code",
        "Remitter_Bank_Code",
      ];
      let app_data = [];
      let n = 1;
      let claimids = _.map(this.claims, "ClaimEMIID");

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      let promiseupdate = apis.UpdateClaimPayment({
        UserID: LoginID,
        ClaimIDs: claimids,
      });

      try {
        let result = await promiseupdate;
        if (result.status == 200) {
          await this.claims.forEach((element) => {
            //Excel format changed for AEPS from 12th Nov 2021
            /*
            let obj = {
              "SR. NO.": "",
              "SENDER NAME": "",
              "DEBIT ACCOUNT NO.": "",
              "BENEFICIARY NAME": "",
              "AADHAR ID": "",
              "BENEFICIARY A/C NO.": "",
              "BENEFICIARY IFSC CODE": "",
              "BENEFICIARY BANK NAME": "",
              "BENEFICIARY  BRANCH NAME": "",
              AMOUNT: "",
              REMARKS: "",
            };
            obj["SR. NO."] = n;
            obj["SENDER NAME"] = element.BankBeneficiaryName;
            obj["DEBIT ACCOUNT NO."] = element.BoardAccountNo;
            obj["BENEFICIARY NAME"] = this.titleCase(element.FullName);
            obj["AADHAR ID"] = element.AdharNo;
            obj["BENEFICIARY A/C NO."] = element.BankAccountNo;
            obj["BENEFICIARY IFSC CODE"] = element.BankIfscCode;
            obj["BENEFICIARY BANK NAME"] = element.BankName;
            obj["BENEFICIARY  BRANCH NAME"] = element.BranchName;
            obj["AMOUNT"] = element.ApprovedAmount;
            obj["REMARKS"] = element.ClaimEMIID;
            */
            let obj = {
              "Sr. No.": "",
              "Debit Account": "",
              "Payment Date": "",
              "Beneficiary Name": "",
              "LOI Number": "",
              "Beneficiary Aadhaar Number": "",
              Amount: "",
              Taluka: "",
              District: "",
              "Mobile No.": "",
              Email: "",
              Zip: "",
              "Corporations Remarks": "",
              "Destination Bank IIN": "",
              "Payment Product Code": "ABPS",
              Remitter_Bank_Code: "ICICI",
            };
            obj["Sr. No."] = n;
            obj["Debit Account"] = element.BoardAccountNo;
            obj["Payment Date"] = element.RptDt;
            obj["Beneficiary Name"] = this.titleCase(element.FullName);
            obj["LOI Number"] = element.LOINumber;
            obj["Beneficiary Aadhaar Number"] = element.AdharNo;
            obj["Amount"] = element.ApprovedAmount;
            obj["Taluka"] = element.TalukaName;
            obj["District"] = element.DistrictName;
            obj["Mobile No."] = element.Mobile;
            obj["Email"] = element.EmailID;
            obj["Zip"] = element.PinCode;
            obj["Corporations Remarks"] = element.ClaimEMIID;
            app_data.push(obj);
            n++;
          });

          var vc = this;
          var wb = XLSX.utils.book_new();
          var ws = XLSX.utils.json_to_sheet(app_data, { header: columns });
          /*
          var ws = XLSX.utils.json_to_sheet(
            [
              {
                A: "                                                                                                                         MAHARASHTRA RAJYA ITAR MAGAS VARGIY VITTA ANI VIKAS MANDAL LTD",
                B: "",
                C: "",
                D: "",
                E: "",
                F: "",
                G: "",
                H: "",
                I: "",
                J: "",
              },
            ],
            {
              header: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
              skipHeader: true,
            }
          );
          const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }];
          ws["!merges"] = merge;

          ws["A1"].s = {
            font: {
              sz: 12,
              bold: true,
              color: {
                rgb: "FFFFAA00",
              },
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrap_text: true,
            },
          };

          var d = new Date();
          XLSX.utils.sheet_add_json(
            ws,
            [
              {
                A: "",
                B: "",
                C: "",
                D: "",
                E: "",
                F: "",
                G: "",
                H: "",
                I: "Date:",
                J: d.toDateString(),
              },
            ],
            { skipHeader: true, origin: "A2" }
          );

          XLSX.utils.sheet_add_json(ws, app_data, {
            header: columns,
            origin: "A4",
          });
          */
          ws["!cols"] = [
            { wpx: 30 },
            { wpx: 125 },
            { wpx: 120 },
            { wpx: 125 },
            { wpx: 125 },
            { wpx: 120 },
            { wpx: 75 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 90 },
            { wpx: 125 }
          ];
          XLSX.utils.book_append_sheet(wb, ws, "Claim_Payment");
          XLSX.writeFile(wb, "Claim_Payments.xlsx");
        } else {
          this.$dialog.alert("Processing Error while Updating Status");
        }
      } catch (err) {
        this.$dialog.alert("Server Error while Updating Status");
      }
    },

    titleCase(str) {
      if ((str != null) & (str != undefined)) {
        return str
          .trim()
          .toLowerCase()
          .split(" ")
          .map(function (word) {
            if (word) {
              return word.replace(word[0], word[0].toUpperCase());
            } else {
              return "";
            }
          })
          .join(" ");
      }
    },
    //ReadClaimRejectionReason
  },
  // created() {
  //   var dt = new Date();
  //   var dtInMs = dt.getTime();
  //   dtInMs -= 60 * 1000 * 60 * 24 * 30; //30 Days
  //   dt.setTime(dtInMs);

  //   this.UpdateDate[0] = dt;
  //   this.UpdateDate[1] = new Date();
  // },
  mounted() {
    this.form.DistrictID = this.$store.getters.getDistrict;
    this.form.LoanType = this.$store.getters.getLoanType;
    this.form.ClaimStatus = 0; //this.$store.getters.getAppStatus;
    this.form.StatusOwner = this.$store.getters.getStatusOwner;

    var userinfo = this.$store.getters.loggedUser;
    this.RoleID = userinfo.RoleID;

    // if (this.form.ClaimStatus == 0) {
    //   switch (this.RoleID) {
    //     case 6:
    //       this.form.ClaimStatus = 1;
    //       break;
    //     case 5:
    //       this.form.ClaimStatus = 2;
    //       break;
    //     case 4:
    //       this.form.ClaimStatus = 3;
    //       break;
    //     default:
    //       this.form.ClaimStatus = 1;
    //       break;
    //   }
    // }

    this.getDisbursals();
    this.getApprovalStatus();
    this.getPaymentStatus();
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.getSchemes();
    this.ReadBanks();

    let promise = apis.ReadClaimStatusByRole({ RoleTypeID: this.RoleID });

    promise
      .then((response) => {
        if (response.status == 200) {
          this.ApprovalStatusAll = response.body;
        }
      })
      .catch((err) => {});

    this.formclm.UserID = userinfo.UserId;

    let promiseR = apis.ReadClaimRejectionReason();

    promiseR
      .then((response) => {
        if (response.status == 200) {
          this.RejectReasons = response.body;
        }
      })
      .catch((err) => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  },
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  /* border-collapse: collapse; */
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ClaimApproval/ClaimList.vue